/**
 * Caminho-base da aplicação.
 *
 * Permite servir o painel sob um subcaminho de um domínio existente
 * (`https://empresa.com.br/indoorplay`) em vez de exigir um domínio ou
 * subdomínio dedicado — cenário comum em instalação on-premise e em
 * revenda, onde o cliente já tem um site no domínio principal.
 *
 * O Next prefixa sozinho o que passa por `Link`, `router` e assets estáticos.
 * O que ele **não** prefixa é `fetch` com caminho absoluto, e é para isso que
 * este helper existe.
 *
 * Vazio (o padrão) mantém o comportamento de servir na raiz.
 */
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? '';

/** Prefixa um caminho interno da aplicação. */
export function withBasePath(path: string): string {
  if (!BASE_PATH) return path;
  return `${BASE_PATH}${path.startsWith('/') ? path : `/${path}`}`;
}
